export default "__VITE_ASSET__CgrLTdjW__"